// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditableSection_wrap__iKChL","toolbar":"EditableSection_toolbar__M0PTM","editButton":"EditableSection_editButton__nRzdN"};